<template>
  <div>
    <v-file-input
      label="Plik *.pptx"
      prepend-icon="mdi-file-powerpoint"
      accept=".pptx"
      outlined
      clearable
      :error-messages="errors"
      v-model="url"
      @change="upload"
    ></v-file-input>
    <v-dialog
      v-model="loaderDialog"
      overlay-opacity="0.8"
      persistent
      width="350"
    >
      <v-card color="primary" dark>
        <v-card-text>
          <p class="pt-4">Przesyłanie pliku *.pptx, proszę czekać...</p>
          <v-progress-linear indeterminate color="white"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MediaApi from '@/api/mediaApi';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      dialog: false,
      loaderDialog: false,
      errors: [],
      url: null
    };
  },
  computed: mapAccountState(['token']),
  methods: {
    async upload(ev) {
      this.errors = [];
      if (!ev) {
        return;
      }

      if (ev && ev.name.split('.').pop() !== 'pptx') {
        this.errors = ['Przesłany plik nie posiada rozszerzenia: *.pptx'];
        this.url = null;
        return;
      }

      this.loaderDialog = true;
      try {
        const response = await new MediaApi(this.token).uploadPptx(ev);
        this.$emit('uploaded', { slides: response.data.result });
        this.loaderDialog = false;
        this.$emit('close');
      } catch (err) {
        console.error(err);
        // TODO: handle
      } finally {
        this.loaderDialog = false;
      }
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>
